import { render } from "./incomeReport.vue?vue&type=template&id=63e3e09b&ts=true"
import script from "./incomeReport.vue?vue&type=script&lang=ts"
export * from "./incomeReport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__